module.exports = __webpack_public_path__ + "media/images/svg-sprite-items/payment/payment-on-invoice-nl-7d2c6a538a5b39c2cb4b29d3535d4463.svg";